export const SHOW_ALERT = 'alerts/SHOW_ALERT';
export const CLOSE_ALERT = 'alerts/CLOSE_ALERT';
export const RESET_ALERT_STATE = 'alerts/RESET_ALERT_STATE';
